import { ImageHelper } from '@/lib/helpers/image.helper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

interface ProductInfoFreeshipProps {
  price: number
}

export const ProductInfoFreeship = ({ price }: ProductInfoFreeshipProps) => {
  const isFreeship = price >= 200000
  const t = useTranslations('product_detail.title')

  return (
    <div className='flex items-center justify-between py-1'>
      <div className='flex items-center gap-2 text-sm'>
        <Image
          src={ImageHelper.getN7ImageUrl('/image/2026/04/15/icon4.png')}
          alt={t('freeship')}
          width={18}
          height={18}
        />
        <span>Freeship {!isFreeship ? t('freeship_condition') : null}</span>
      </div>
    </div>
  )
}
